import { CatalogPage } from '@/features/catalog/CatalogPage';
import { useT } from '@/i18n/LocaleProvider';
import { useDocumentTitle } from '@/lib/useDocumentTitle';

export function CatalogRoute() {
  const t = useT();
  useDocumentTitle(t('nav.catalog'));
  return <CatalogPage />;
}
